<template>
    <div class="container">
        <div class="news" v-if="newsInfo">
            <div class="title">{{newsInfo.title}}</div>
            <div class="time">{{newsInfo.updateTime}}</div>
            <div class="content" v-html="newsInfo.content"></div>
        </div>
        <Hot></Hot>
    </div>
</template>

<script>
import * as apis from '../fetch/common';
import Hot from '../components/hot/Hot';

import { mapActions } from 'vuex';

export default {
    name: 'news',
    components: {
        Hot,
    },
    data() {
        return {
            newsInfo: null,
        };
    },
    watch: {
        $route(val) {
            this.getNews(val.params.id);
        },
    },
    methods: {
        ...mapActions(['setBreadcrumb']),
        getNews: function(id) {
            apis.getArticleById(id).then(res => {
                this.newsInfo = res;
                this.setBreadcrumb(res.title);
            });
        },
    },
    mounted: function() {
        this.getNews(this.$route.params.id);
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}

.news {
    width: 895px;
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(228, 228, 228, 0.5);
    border-radius: 10px;
    margin-right: 10px;
    padding: 32px;
    height: max-content;
    .title {
        font-size: 20px;
        color: #2b2b2b;
        text-align: center;
    }
    .time {
        font-size: 18px;
        color: #8b8b8b;
        text-align: center;
        margin-top: 16px;
        margin-bottom: 24px;
    }
}
</style>